import { useUuiContext } from '@epam/uui-core';
import DeleteModalBotIcon from 'assets/icons/delete-modal-bot.svg';
import ConfirmBotIcon from 'assets/icons/confirm-modal-bot.svg';
import SaveModalBotIcon from 'assets/icons/not-saved-bot.svg';
import { Modal, ModalActionType, ModalFnArgs } from 'components/modals';

export const useModal = () => {
  const { uuiModals } = useUuiContext();

  const useSaveModal = (options: ModalFnArgs) => {
    const {
      text,
      highlight,
      successAction,
      abortAction,
      isDisabled,
      onSuccess,
      onAbort = () => {},
      onClose = () => {},
    } = options;

    uuiModals.show(({ abort, success, isActive, key, zIndex }) => (
      <Modal
        context={{ abort, success, isActive, key, zIndex }}
        data={{
          text,
          highlight,
          title: 'Confirm your action',
          icon: SaveModalBotIcon,
          successAction: successAction ?? 'Save changes',
          abortAction: abortAction ?? 'Discard changes',
        }}
        meta={{ onSuccess, onAbort, onClose, isDisabled, actionType: 'save' }}
      />
    ));
  };

  const useDeleteModal = (options: ModalFnArgs) => {
    const {
      text,
      highlight,
      successAction,
      abortAction,
      onSuccess,
      onAbort = () => {},
      onClose = () => {},
    } = options;

    uuiModals.show(({ abort, success, isActive, key, zIndex }) => (
      <Modal
        context={{ abort, success, isActive, key, zIndex }}
        data={{
          text,
          highlight,
          title: 'Confirm your action',
          icon: DeleteModalBotIcon,
          successAction: successAction ?? 'Delete',
          abortAction: abortAction ?? 'Cancel',
        }}
        meta={{ onSuccess, onAbort, onClose, actionType: 'delete' }}
      />
    ));
  };

  const useConfirmModal = (options: ModalFnArgs) => {
    const {
      text,
      highlight,
      successAction,
      abortAction,
      onSuccess,
      onAbort = () => {},
      onClose = () => {},
    } = options;

    uuiModals.show(({ abort, success, isActive, key, zIndex }) => (
      <Modal
        context={{ abort, success, isActive, key, zIndex }}
        data={{
          text,
          highlight,
          title: 'Confirm your action',
          icon: ConfirmBotIcon,
          successAction: successAction ?? 'Yes',
          abortAction: abortAction ?? 'Cancel',
        }}
        meta={{ onSuccess, onAbort, onClose, actionType: 'confirm' }}
      />
    ));
  };

  const methods: Record<
    Lowercase<ModalActionType>,
    (options: ModalFnArgs) => void
  > = {
    save: useSaveModal,
    delete: useDeleteModal,
    confirm: useConfirmModal,
  };

  return methods;
};
